import { Tab } from '@headlessui/react';

import ErrorBoundary from '~components/generic/error-boundary/ErrorBoundary';
import { BrandguideResultsController } from '~components/search/controller/BrandguideResultsController';
import MediaLibraryHeaderController from '~components/search/controller/MediaLibraryHeaderController';
import { MediaLibraryResultsController } from '~components/search/controller/MediaLibraryResultsController';
import MediaLibraryProviderBag from '~modules/media-library/context/MediaLibraryProviderBag';

export const SearchContent = () => {
  return (
    <Tab.Panels className="relative">
      <Tab.Panel>
        <BrandguideResultsController />
      </Tab.Panel>
      <Tab.Panel>
        <ErrorBoundary>
          <MediaLibraryProviderBag>
            <MediaLibraryHeaderController />
            <MediaLibraryResultsController />
          </MediaLibraryProviderBag>
        </ErrorBoundary>
      </Tab.Panel>
    </Tab.Panels>
  );
};
